<template>
	<inertia-head title="Beneficiaries" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Beneficiaries</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						List of member's beneficiaries
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded">
			<div class="block-content">
				<div v-if="beneficiaries.data.length > 0">
					<div class="table-responsive">
						<table
							class="table table-striped table-borderless table-hover table-vcenter"
						>
							<thead class="text-center">
								<tr>
									<th>User ID</th>
									<th>First Name</th>
									<th>Last Name</th>
									<th>Birthday</th>
									<th>Relationship</th>
								</tr>
							</thead>
							<tbody class="fs-sm">
								<tr
									v-for="beneficiary in beneficiaries.data"
									:key="beneficiary.id"
								>
									<td>{{ beneficiary.user_id }}</td>
									<td>{{ beneficiary.fname }}</td>
									<td>{{ beneficiary.lname }}</td>
									<td>{{ beneficiary.birthday }}</td>
									<td>{{ beneficiary.relationship }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- Pagination -->
					<pagination :collections="beneficiaries" />
				</div>
				<div v-else class="alert alert-warning">NO BENEFICIARIES FOUND</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		beneficiaries: Object,
	},
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
